import { useEffect, useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { alpha } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Dialog from '@mui/material/Dialog';

// project imports
import Transitions from 'ui-component/extended/Transitions';

// assets
import TranslateTwoToneIcon from '@mui/icons-material/TranslateTwoTone';
import useConfig from 'hooks/useConfig';
import AnimateButton from 'ui-component/extended/AnimateButton';

// types
import { I18n, ThemeMode } from 'types/config';
import Login from 'views/pages/authentication/Login3';
import { FormattedMessage } from 'react-intl';
import useAuth from 'hooks/useAuth';

// ==============================|| LOCALIZATION ||============================== //

const LoginSection = ({ loginForceOpen, forceOpen }: { loginForceOpen: boolean; forceOpen: Function }) => {
    const { forceLogin } = useAuth();
    const { mode, borderRadius, i18n, onChangeLocale } = useConfig();

    const theme = useTheme();
    const downMD = useMediaQuery(theme.breakpoints.down('md'));

    const [open, setOpen] = useState(loginForceOpen || false);
    const anchorRef = useRef<any>(null);

    const handleListItemClick = (
        event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement, MouseEvent> | undefined,
        lng: I18n
    ) => {
        onChangeLocale(lng);
        setOpen(false);
    };

    const forceOpenFn = (type: string) => {
        forceOpen(type);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: MouseEvent | TouchEvent) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        forceLogin(false);
        forceOpen('close');
        setOpen(false);
    };

    const prevOpen = useRef(open);

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    useEffect(() => {
        if (loginForceOpen) setOpen(true);
    }, [loginForceOpen]);

    return (
        <>
            <Box sx={{ ml: { xs: 1, sm: 2 }, mr: { xs: 0, sm: 0 }, position: 'relative' }}>
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        // border: '1px solid',
                        // borderColor: mode === ThemeMode.DARK ? 'dark.main' : 'primary.light',
                        borderRadius: '10px',
                        // backgroundColor: theme.palette.secondary.main,
                        // bgcolor: '#08B579',
                        color: '#fff',
                        transition: 'all .2s ease-in-out',
                        cursor: 'pointer',
                        padding: '0px 10px',
                        fontSize: '1rem',
                        fontWeight: '600',
                        fontFamily: '"Manrope", sans-serif',
                        height:'56px',
                        background:'none',
                        width: '138px',
                        border:'1px solid',
                        borderColor:alpha(theme.palette.secondary.main, 1),
                        [theme.breakpoints.down('sm')]: { 
                           
                            height:'44px',
                            fontSize: '0.875rem',
                            fontWeight: '600',
                              
                          },
                        '&[aria-controls="menu-list-grow"],&:hover': {
                            // borderColor: '#08B579',
                            bgcolor: 'none',
                            color: '#fff',
                        },
                        '@media (max-width: 600px)': {
                            width: '60px'
                        },
                        '&:hover': {
                            // bgcolor: mode === ThemeMode.DARK ? 'secondary.main' : 'secondary.dark',
                            // background: theme.palette.mode === ThemeMode.DARK ? theme.palette.grey[900] : theme.palette.common.white,
                            backgroundColor: 'none',
                            // color: mode === ThemeMode.DARK ? 'secondary.light' : 'secondary.light'
                            color: '#fff',
                        }
                    }}
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    alt="language"
                    onClick={handleToggle}
                    color="inherit"
                >
                    <FormattedMessage id="Login" />
                </Avatar>
            </Box>

            {open && (
                <Dialog sx={{ borderRadius: '0px' }} onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
                    {open && (
                        <>
                            <Card className="343434" sx={{ overflow: 'auto', borderRadius: '0px', background: 'transparent' }}>
                                <CardContent sx={{ p: 0, borderRadius: '0px', background: '#fff', pb: '0px !important' }}>
                                    {open && <Login forceOpen={forceOpenFn} />}
                                </CardContent>
                            </Card>
                        </>
                    )}
                </Dialog>
            )}

            {/* <Popper
                placement={downMD ? 'bottom-start' : 'bottom'}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                sx={{}}
                modifiers={[
                    {
                        name: 'offset',
                        options: {
                            offset: [downMD ? 0 : 0, 20]
                        }
                    }
                ]}
            >
                {({ TransitionProps }) => (
                    <ClickAwayListener onClickAway={handleClose}>
                        <Transitions position={downMD ? 'top-left' : 'top'} in={open} {...TransitionProps}>
                            <Paper sx={{ borderRadius: '0px', background: '#fff' }} elevation={16}>
                                {open && <Login forceOpen={forceOpenFn} />}
                            </Paper>
                        </Transitions>
                    </ClickAwayListener>
                )}
            </Popper> */}
        </>
    );
};

export default LoginSection;
